<!-- Card Wrapper (optional) -->
<div 
  *ngIf="showCard; else chartOnly"
  class="bg-white rounded-xl h-full flex flex-col {{darkThemeClass}}"
  [ngClass]="cardClass"
  [style.padding]="cardPadding"
>
  <!-- Header Section -->
  <div 
    *ngIf="title || subtitle"
    class="mb-4"
    [ngClass]="headerClass"
  >
    <h3 
      *ngIf="title"
      class="text-base text-[#141437] dark:text-white m-0 mb-1 leading-snug"
      [ngClass]="titleClass"
    >{{ title }}</h3>
    <p 
      *ngIf="subtitle"
      class="text-sm text-gray-500 dark:text-slate-400 m-0 leading-snug"
      [ngClass]="subtitleClass"
    >{{ subtitle }}</p>
  </div>

  <!-- Legend (Top Position) -->
  <div 
    *ngIf="showHtmlLegend && legend.position === 'top'"
    class="flex flex-wrap pt-3"
    [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
    [style.gap.px]="legend.itemGap || 24"
  >
    <div 
      *ngFor="let item of legendItems" 
      class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
    >
      <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
      <span 
        class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
        [ngClass]="legendLabelClass"
      >{{ item.name }}</span>
    </div>
  </div>

  <!-- Chart Container with Legend Layout -->
  <div 
    class="flex flex-1 min-h-0 gap-4"
    [class.flex-row]="legend.position === 'left' || legend.position === 'right'"
  >
    <!-- Legend (Left Position) -->
    <div 
      *ngIf="showHtmlLegend && legend.position === 'left'"
      class="flex flex-col justify-center px-2"
      [ngClass]="legendClass"
      [style.gap.px]="legend.itemGap || 12"
    >
      <div 
        *ngFor="let item of legendItems" 
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
      >
        <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span 
          class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass"
        >{{ item.name }}</span>
      </div>
    </div>

    <!-- Chart Container -->
    <div 
      #chartContainer 
      class="flex-1 min-h-[200px] relative w-full"
    ></div>

    <!-- Legend (Right Position) -->
    <div 
      *ngIf="showHtmlLegend && legend.position === 'right'"
      class="flex flex-col justify-center px-2"
      [ngClass]="legendClass"
      [style.gap.px]="legend.itemGap || 12"
    >
      <div 
        *ngFor="let item of legendItems" 
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
      >
        <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span 
          class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass"
        >{{ item.name }}</span>
      </div>
    </div>
  </div>

  <!-- Legend (Bottom Position) -->
  <div 
    *ngIf="showHtmlLegend && legend.position === 'bottom'"
    class="flex flex-wrap pt-3"
    [ngClass]="[
      legendClass, 
      legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center',
      useStandardizedLegend ? 'absolute bottom-2 left-0 right-0 pt-0' : ''
    ]"
    [style.gap.px]="legend.itemGap || 24"
  >
    <div 
      *ngFor="let item of legendItems" 
      class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
    >
      <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
      <span 
        class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
        [ngClass]="legendLabelClass"
      >{{ item.name }}</span>
    </div>
  </div>
</div>

<!-- Chart Only (no card wrapper) -->
<ng-template #chartOnly>
  <div class="w-full h-full flex flex-col">
    <!-- Legend (Top Position) -->
    <div 
      *ngIf="showHtmlLegend && legend.position === 'top'"
      class="flex flex-wrap pt-3"
      [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
      [style.gap.px]="legend.itemGap || 24"
    >
      <div 
        *ngFor="let item of legendItems" 
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
      >
        <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span 
          class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass"
        >{{ item.name }}</span>
      </div>
    </div>

    <div 
      class="flex flex-1 min-h-0 gap-4"
      [class.flex-row]="legend.position === 'left' || legend.position === 'right'"
    >
      <!-- Legend (Left Position) -->
      <div 
        *ngIf="showHtmlLegend && legend.position === 'left'"
        class="flex flex-col justify-center px-2"
        [ngClass]="legendClass"
        [style.gap.px]="legend.itemGap || 12"
      >
        <div 
          *ngFor="let item of legendItems" 
          class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
        >
          <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
          <span 
            class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
            [ngClass]="legendLabelClass"
          >{{ item.name }}</span>
        </div>
      </div>

      <!-- Chart Container -->
      <div 
        #chartContainer 
        class="flex-1 min-h-[200px] relative w-full"
      ></div>

      <!-- Legend (Right Position) -->
      <div 
        *ngIf="showHtmlLegend && legend.position === 'right'"
        class="flex flex-col justify-center px-2"
        [ngClass]="legendClass"
        [style.gap.px]="legend.itemGap || 12"
      >
        <div 
          *ngFor="let item of legendItems" 
          class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
        >
          <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
          <span 
            class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
            [ngClass]="legendLabelClass"
          >{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- Legend (Bottom Position) -->
    <div 
      *ngIf="showHtmlLegend && legend.position === 'bottom'"
      class="flex flex-wrap pt-3"
      [ngClass]="[legendClass, legend.align === 'start' ? 'justify-start' : legend.align === 'end' ? 'justify-end' : 'justify-center']"
      [style.gap.px]="legend.itemGap || 24"
    >
      <div 
        *ngFor="let item of legendItems" 
        class="flex items-center gap-2 cursor-default transition-opacity duration-200 hover:opacity-80"
      >
        <span class="w-2.5 h-2.5 rounded-full shrink-0" [style.background]="item.color"></span>
        <span 
          class="text-[13px] font-medium text-gray-500 dark:text-slate-400 whitespace-nowrap"
          [ngClass]="legendLabelClass"
        >{{ item.name }}</span>
      </div>
    </div>
  </div>
</ng-template>
